import React from "react"
import autobind from "class-autobind"
import { ETrendTimeScope, IGroupedTrend, ITrendSearch } from "../../../models/data/dashboard/Trends/TrendsData"
import TrendSummaryPanelItem from "./TrendSummaryPanelItem"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"

declare global {
    interface Window {
        Intercom: any
    }
}

interface IProps {
    data: ITrendSearch
    onSelectNewItem(newItem: IGroupedTrend, selectedIds: string[]): void
    scope: ETrendTimeScope
    selectedIds?: string[]
}

interface IState {
    selectedIds: string[];
}

export default class TrendSummaryPanel extends React.Component<IProps, IState> {    
    constructor(props) {
        super(props);
        this.state = {
            selectedIds: this.props.selectedIds, // Ensure it's an array
        };
        autobind(this);
    }
        
    componentDidMount() {
        // If props.selectedId is available, make sure it's reflected in state immediately
        if (this.props.selectedIds) {
            this.setState({ selectedIds: this.props.selectedIds }); 
        }
    }

    componentWillUnmount() {
    }
    handleItemClick = (trendGroup: IGroupedTrend) => {
        const newSelectedIds = this.state.selectedIds.includes(trendGroup.Settings.Id)
          ? this.state.selectedIds.filter((id) => id !== trendGroup.Settings.Id)
          : [...this.state.selectedIds, trendGroup.Settings.Id];
    
        this.setState({ selectedIds: newSelectedIds }, () => {
          console.log("TrendSummaryPanel - After setState:", this.state.selectedIds); // Log after state update
          this.props.onSelectNewItem(trendGroup, newSelectedIds);
        });
      };

    render() {
    const { data, scope } = this.props;
    const { selectedIds } = this.state;

    let filterHierarchyId = HierarchySettingsStore.getGlobalLevelItemFilterId();
    if (filterHierarchyId != null && filterHierarchyId === "") {
      filterHierarchyId = null;
    }

    return (
      <div
        style={{ backgroundColor: "#444444", color: "#cfcfcf", height: "100%" }}
      >
        {data &&
          data.GroupedTrends.filter(
            (item) => item.HierarchyId === filterHierarchyId && !item.LeafNode
          ).map((trendGroup, i) => (
            <div key={i} onClick={() => this.handleItemClick(trendGroup)}>
              <TrendSummaryPanelItem
                groupedTrend={trendGroup}
                selected={selectedIds.includes(trendGroup.Settings.Id)}
                scope={scope}
              />
            </div>
          ))}
      </div>
    );
  }
}

